module.exports = __webpack_public_path__ + "media/images/elionline/icons/da_assegnare_filtri_attivo-1c6f03c2065886cfd44d615103ae7524.svg";